// Mock data for Кладоффка24 - Premium Self-Storage Service

export const storageUnits = [
  {
    id: 1,
    name: "XS",
    size: "1 м²",
    volume: "2.5 м³",
    dimensions: "1×1×2.5 м",
    price: 2500,
    pricePerDay: 85,
    available: true,
    popular: false,
    description: "Для сезонных вещей, документов",
    fits: ["2-3 коробки", "Велосипед", "Шины"],
    image: "/images/storage-4.jpg"
  },
  {
    id: 2,
    name: "S",
    size: "2 м²",
    volume: "5 м³",
    dimensions: "2×1×2.5 м",
    price: 4000,
    pricePerDay: 135,
    available: true,
    popular: false,
    description: "Для небольшого переезда",
    fits: ["5-7 коробок", "Диван", "Холодильник"],
    image: "/images/storage-4.jpg"
  },
  {
    id: 3,
    name: "M",
    size: "4 м²",
    volume: "10 м³",
    dimensions: "2×2×2.5 м",
    price: 6500,
    pricePerDay: 220,
    available: true,
    popular: true,
    description: "Популярный выбор для квартиры",
    fits: ["Однокомнатная квартира", "Офисная мебель"],
    image: "/images/storage-4.jpg"
  },
  {
    id: 4,
    name: "L",
    size: "6 м²",
    volume: "15 м³",
    dimensions: "3×2×2.5 м",
    price: 9000,
    pricePerDay: 300,
    available: true,
    popular: false,
    description: "Для двухкомнатной квартиры",
    fits: ["Двухкомнатная квартира", "Товарный запас"],
    image: "/images/storage-4.jpg"
  },
  {
    id: 5,
    name: "XL",
    size: "10 м²",
    volume: "25 м³",
    dimensions: "4×2.5×2.5 м",
    price: 14000,
    pricePerDay: 470,
    available: true,
    popular: false,
    description: "Для большого переезда или бизнеса",
    fits: ["Трёхкомнатная квартира", "Склад интернет-магазина"],
    image: "/images/storage-4.jpg"
  },
  {
    id: 6,
    name: "XXL",
    size: "15 м²",
    volume: "37 м³",
    dimensions: "5×3×2.5 м",
    price: 20000,
    pricePerDay: 670,
    available: false,
    popular: false,
    description: "Максимальное пространство",
    fits: ["Загородный дом", "Коммерческое хранение"],
    image: "/images/storage-4.jpg"
  }
];

export const featureCards = [
  {
    id: 1,
    title: "Доступ 24/7",
    description: "Заходите в любое время дня и ночи. Персональный код доступа.",
    image: "/images/storage-4.jpg"
  },
  {
    id: 2,
    title: "Охрана и видеонаблюдение",
    description: "Круглосуточный мониторинг. Более 50 камер на территории.",
    image: "/images/storage-5.jpg"
  },
  {
    id: 3,
    title: "Чистота и климат",
    description: "Сухо, чисто, отапливаемо. Оптимальные условия хранения.",
    image: "/images/storage-6.jpg"
  },
  {
    id: 4,
    title: "Любые размеры",
    description: "От 1 до 50 м². Подберём под ваши задачи.",
    image: "/images/storage-10.jpg"
  }
];

export const howItWorks = [
  {
    step: 1,
    title: "Выберите размер",
    description: "Используйте калькулятор или позвоните — поможем определить нужный объём"
  },
  {
    step: 2,
    title: "Забронируйте онлайн",
    description: "Оформите бронь за 2 минуты. Без предоплаты и скрытых платежей"
  },
  {
    step: 3,
    title: "Привезите вещи",
    description: "Приезжайте в удобное время. Поможем с погрузкой при необходимости"
  },
  {
    step: 4,
    title: "Пользуйтесь",
    description: "Доступ 24/7 по персональному коду. Забирайте вещи когда нужно"
  }
];

export const securityFeatures = [
  {
    icon: "Shield",
    title: "Охрана 24/7",
    description: "Профессиональная охрана на территории круглосуточно"
  },
  {
    icon: "Video",
    title: "50+ камер",
    description: "Видеонаблюдение по всей территории с записью"
  },
  {
    icon: "Fingerprint",
    title: "Персональный доступ",
    description: "Индивидуальный код — только вы открываете свой бокс"
  },
  {
    icon: "Bell",
    title: "Сигнализация",
    description: "Каждый бокс оборудован датчиками"
  },
  {
    icon: "Flame",
    title: "Пожарная безопасность",
    description: "Современная система пожаротушения"
  },
  {
    icon: "FileCheck",
    title: "Страхование",
    description: "Возможность застраховать ваши вещи"
  }
];

export const faqItems = [
  {
    question: "Как получить доступ к боксу?",
    answer: "После оформления договора вы получаете персональный код. С ним вы можете зайти на территорию и открыть свой бокс в любое время — 24 часа в сутки, 7 дней в неделю."
  },
  {
    question: "Какие вещи можно хранить?",
    answer: "Любые бытовые вещи: мебель, технику, одежду, спортинвентарь, документы, товары для бизнеса. Запрещено хранить опасные, легковоспламеняющиеся вещества и продукты питания."
  },
  {
    question: "На какой срок можно арендовать?",
    answer: "Минимальный срок — 1 месяц. Максимальный не ограничен. При аренде от 3 месяцев действуют скидки до 5%."
  },
  {
    question: "Можно ли поменять размер бокса?",
    answer: "Да, вы можете перейти на бокс большего или меньшего размера при наличии свободных мест. Просто свяжитесь с нами."
  },
  {
    question: "Есть ли помощь с погрузкой?",
    answer: "Да, мы можем организовать помощь грузчиков и предоставить тележки для перевозки вещей по территории."
  },
  {
    question: "Как происходит оплата?",
    answer: "Оплата ежемесячная, любым удобным способом: картой, переводом или наличными. При оплате за несколько месяцев — скидка."
  }
];

export const contactInfo = {
  address: "г. Краснодар, мкр Любимово",
  addresses: [
    // Координаты с yandex.ru/maps по адресам мкр Любимово
    { label: "Склад №1", full: "г. Краснодар, мкр Любимово, д. 18", short: "мкр Любимово, д. 18", lon: 39.043324, lat: 45.079091 },
    { label: "Склад №2", full: "г. Краснодар, мкр Любимово, д. 7",  short: "мкр Любимово, д. 7",  lon: 39.037629, lat: 45.084087 },
    { label: "Склад №3", full: "г. Краснодар, мкр Любимово, д. 11", short: "мкр Любимово, д. 11", lon: 39.037602, lat: 45.082089 },
  ],
  city: "Краснодар",
  phone: "+7 918 436-22-55",
  phoneRaw: "79184362255",
  email: "kladoffka24-krd@yandex.ru",
  workingHours: "Офис: 9:00–21:00 / Доступ: 24/7"
};

// Реквизиты юридического лица
export const legalInfo = {
  name: 'ООО "СОВРЕМЕННЫЕ РЕШЕНИЯ"',
  inn: "2311391022",
  kpp: "231101001",
  ogrn: "1262300015768",
  legalAddress: "350022, Краснодарский край, г. Краснодар, ул. Восточно-Кругликовская, д. 82, помещ. 1014/1",
  bank: 'ФИЛИАЛ "РОСТОВСКИЙ" АО "АЛЬФА-БАНК"',
  rs: "40702810726210003226",
  ks: "30101810500000000207",
  bik: "046015207",
  taxSystem: "УСН (доходы)",
  director: "Абраамян Сона Арменовна",
  phone: "+7 918 436-22-55",
  email: "kladoffka24-krd@yandex.ru"
};

export const maxBotLink = "https://max.ru/id7751237158_2_bot";
export const maxBotQr = `https://api.qrserver.com/v1/create-qr-code/?size=180x180&data=${encodeURIComponent("https://max.ru/id7751237158_2_bot")}`;

export const companyInfo = {
  name: "Кладоффка24",
  tagline: "Пространство для ваших вещей",
  description: "Современный сервис индивидуального хранения в Краснодаре",
  stats: {
    boxes: "500+",
    clients: "2000+",
    years: "5"
  },
  logo: "/images/logo.png"
};

export const promoItems = [
  {
    id: 1,
    title: "Первый месяц -50%",
    description: "Для новых клиентов при аренде от 3 месяцев",
    code: "FIRST50"
  },
  {
    id: 2,
    title: "Приведи друга",
    description: "Получите месяц бесплатно за каждого приглашённого",
    code: "FRIEND"
  }
];

// Services Section Data
export const servicesData = [
  {
    id: 1,
    icon: "Home",
    title: "Переезд",
    description: "Временное хранение вещей во время ремонта или переезда. Любой срок от 1 месяца.",
    features: ["Гибкие сроки", "Помощь грузчиков", "Упаковочные материалы"],
    image: "/images/service-moving.jpg"
  },
  {
    id: 2,
    icon: "Snowflake",
    title: "Сезонные вещи",
    description: "Храните зимнюю резину, велосипеды, лыжи и сезонную одежду — освободите дом.",
    features: ["Климат-контроль", "Компактные боксы", "Доступ 24/7"],
    image: "/images/service-seasonal.jpg"
  },
  {
    id: 3,
    icon: "Archive",
    title: "Архив документов",
    description: "Безопасное хранение документации с контролем влажности и температуры.",
    features: ["Сухое помещение", "Пожарная защита", "Конфиденциальность"],
    image: "/images/service-archive.jpg"
  },
  {
    id: 4,
    icon: "Sofa",
    title: "Хранение мебели",
    description: "Сохраним вашу мебель в идеальном состоянии в чистом отапливаемом помещении.",
    features: ["Просторные боксы", "Без влаги и пыли", "Погрузка/выгрузка"],
    image: "/images/service-furniture.jpg"
  },
  {
    id: 5,
    icon: "Bike",
    title: "Спортинвентарь",
    description: "Велосипеды, сноуборды, каяки — всё, что занимает много места дома.",
    features: ["Специальные крепления", "Любые размеры", "Круглосуточный доступ"],
    image: "/images/service-sports.jpg"
  },
  {
    id: 6,
    icon: "Gift",
    title: "Коллекции и ценности",
    description: "Надёжное хранение коллекций, антиквариата и ценных предметов под охраной.",
    features: ["Видеонаблюдение", "Страхование", "Персональный код"],
    image: "/images/service-collections.jpg"
  }
];

// Business Section Data
export const businessServices = [
  {
    id: 1,
    icon: "ShoppingBag",
    title: "Интернет-магазины",
    description: "Склад для товаров вашего онлайн-бизнеса с удобной логистикой.",
    benefits: ["Нет арендной платы офиса", "Масштабируемость", "Удобная отгрузка"],
    price: "Звоните"
  },
  {
    id: 2,
    icon: "Briefcase",
    title: "Офисный архив",
    description: "Освободите офис от документов и оборудования — храните у нас.",
    benefits: ["Экономия на аренде", "Быстрый доступ", "Организация хранения"],
    price: "Звоните"
  },
  {
    id: 3,
    icon: "Truck",
    title: "Логистика и дистрибуция",
    description: "Временное хранение товаров между поставками и отгрузками.",
    benefits: ["Выгодное расположение", "Грузовой въезд", "Гибкие условия"],
    price: "Звоните"
  },
  {
    id: 4,
    icon: "Store",
    title: "Сезонный бизнес",
    description: "Храните торговое оборудование и товары в межсезонье.",
    benefits: ["Оплата только за сезон", "Сохранность товара", "Быстрый старт"],
    price: "Звоните"
  }
];

export const businessStats = [
  { value: "150+", label: "Бизнес-клиентов" },
  { value: "30%", label: "Экономия на аренде" },
  { value: "24/7", label: "Доступ к товарам" },
  { value: "0 ₽", label: "Коммунальные платежи" }
];

export const reviews = [
  {
    id: 1,
    name: 'Алексей М.',
    role: 'Бизнес-аккаунт',
    text: 'Система работает безупречно. Доступ по коду, никаких охранников с ключами. Чисто, сухо, технологично.',
    rating: 5,
    date: '12.10.2023'
  },
  {
    id: 2,
    name: 'Елена В.',
    role: 'Личное хранение',
    text: 'Идеальный порядок. Нравится, что всё автоматизировано. Забронировала, оплатила, привезла вещи. 10 минут.',
    rating: 5,
    date: '15.10.2023'
  },
  {
    id: 3,
    name: 'Дмитрий К.',
    role: 'Сезонное хранение',
    text: 'Храню шины и велосипеды. Камеры везде, чувствую спокойствие за имущество. Рекомендую.',
    rating: 5,
    date: '20.10.2023'
  }
];

// Calculator Data
export const calculatorItems = [
  { id: "sofa", name: "Диван", icon: "Sofa", volume: 2.5 },
  { id: "bed", name: "Кровать", icon: "Bed", volume: 2.0 },
  { id: "wardrobe", name: "Шкаф", icon: "DoorClosed", volume: 2.0 },
  { id: "table", name: "Стол", icon: "Table", volume: 1.0 },
  { id: "chair", name: "Стулья (4 шт)", icon: "Armchair", volume: 0.8 },
  { id: "fridge", name: "Холодильник", icon: "Refrigerator", volume: 1.5 },
  { id: "washer", name: "Стиральная машина", icon: "Waves", volume: 0.8 },
  { id: "tv", name: "Телевизор", icon: "Tv", volume: 0.3 },
  { id: "boxes5", name: "5 коробок", icon: "Package", volume: 0.5 },
  { id: "boxes10", name: "10 коробок", icon: "Packages", volume: 1.0 },
  { id: "bike", name: "Велосипед", icon: "Bike", volume: 0.8 },
  { id: "tires", name: "Комплект шин", icon: "CircleDot", volume: 0.5 }
];

export const calculatorPresets = [
  { 
    id: "studio", 
    name: "Студия", 
    items: ["sofa", "bed", "boxes5", "tv"],
    recommendedSize: "S"
  },
  { 
    id: "1room", 
    name: "1-комнатная", 
    items: ["sofa", "bed", "wardrobe", "table", "fridge", "boxes5"],
    recommendedSize: "M"
  },
  { 
    id: "2room", 
    name: "2-комнатная", 
    items: ["sofa", "bed", "bed", "wardrobe", "wardrobe", "table", "fridge", "washer", "boxes10"],
    recommendedSize: "L"
  },
  { 
    id: "3room", 
    name: "3-комнатная", 
    items: ["sofa", "sofa", "bed", "bed", "bed", "wardrobe", "wardrobe", "table", "chair", "fridge", "washer", "tv", "boxes10", "boxes10"],
    recommendedSize: "XL"
  }
];